export default "__VITE_ASSET__XVqixgmY__"